import { changeColors, getColors } from '@process-advisor/process-miner/api/methods/settings/changeColors';
import { changeLoopDashes, getLoopDashes } from '@process-advisor/process-miner/api/methods/settings/changeLoopDashes';
import { getVisualizerBackgroundColor } from '@process-advisor/process-miner/api/methods/settings/changeVisualizerBackgroundColor';
import { changeStepLabelFontSize, getStepLabelFontSize } from '@process-advisor/process-miner/api/methods/settings/changeStepLabelFontSize';
import { changeNodeLabelFontSize, getNodeLabelFontSize } from '@process-advisor/process-miner/api/methods/settings/changeNodeLabelFontSize';
import { changeShowNodes, getShowNodes } from '@process-advisor/process-miner/api/methods/settings/changeShowNodes';
import { changeStepLabels, getStepLabels } from '@process-advisor/process-miner/api/methods/settings/changeStepLabels';
import { changeStepTooltip, getStepTooltip } from '@process-advisor/process-miner/api/methods/settings/changeStepTooltip';
import { changeDurationFormat, getDurationFormat } from '@process-advisor/process-miner/api/methods/settings/changeDurationFormat';
import { changeNodeLabels, getNodeLabels } from '@process-advisor/process-miner/api/methods/settings/changeNodeLabels';
import { changeStartLabel, getStartLabel } from '@process-advisor/process-miner/api/methods/settings/changeStartEndLabels';
import { changeEndLabel, getEndLabel } from '@process-advisor/process-miner/api/methods/settings/changeStartEndLabels';
import { changeStepWidth, getStepWidth } from '@process-advisor/process-miner/api/methods/settings/changeStepWidth';
import { changeHighlight, getHighlight } from '@process-advisor/process-miner/api/methods/filters/changeHighlight';
import { setProcessFlowDirection, getProcessFlowDirection } from '@process-advisor/process-miner/api/methods/settings/setProcessFlowDirection';
import { changeZoomToFit, getZoomToFit } from '@process-advisor/process-miner/api/methods/settings/changeZoomToFit';
import { setSpacings } from '@process-advisor/process-miner/api/methods/settings/setSpacings';
import { getSpacings } from '@process-advisor/process-miner/api/methods/settings/setSpacings';
import { changeNodeShape, getNodeShape } from '@process-advisor/process-miner/api/methods/settings/changeNodeShape';
import { getActivityColors , changeActivityColors} from '@process-advisor/process-miner/api/methods/settings/changeActivityColors'


export const settingsMethods = {
    changeNodeLabelFontSize,
    getNodeLabelFontSize,
    getStepLabelFontSize,
    changeStepLabelFontSize,
    changeStartLabel,
    getStartLabel,
    changeEndLabel,
    getEndLabel,
    changeStepTooltip,
    getStepTooltip,
    changeDurationFormat,
    getDurationFormat,
    changeColors,
    getColors,
    changeLoopDashes,
    getLoopDashes,
    changeShowNodes,
    getShowNodes,
    changeStepLabels,
    changeHighlight,
    getStepLabels,
    setSpacings,
    getSpacings,
    setProcessFlowDirection,
    getProcessFlowDirection,
    getHighlight,
    changeStepWidth,
    getStepWidth,
    changeNodeLabels,
    getNodeLabels,
    getVisualizerBackgroundColor,
    changeZoomToFit,
    getZoomToFit,
    changeNodeShape,
    getNodeShape,
    getActivityColors,
    changeActivityColors
};
